/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCircuitGround = createReactComponent("circuit-ground", "IconCircuitGround", [
  ["path", { d: "M12 13v-8", key: "svg-0" }],
  ["path", { d: "M4 13h16", key: "svg-1" }],
  ["path", { d: "M7 16h10", key: "svg-2" }],
  ["path", { d: "M10 19h4", key: "svg-3" }]
]);

export { IconCircuitGround as default };
//# sourceMappingURL=IconCircuitGround.js.map
